// src/hooks/useGetSoilSensors.js
import { useState, useEffect, useRef } from 'react';
import { API_URL } from '../config';
import { authFetch } from '../utils';

function useGetSoilSensors() {
  const [soilSensors, setSoilSensors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const firstLoad = useRef(true);

  useEffect(() => {
    let isMounted = true;

    const fetchSoilSensors = () => {
      authFetch(`${API_URL}soil-sensors/facility/paterna`)
        .then((res) => {
          if (!res.ok) throw new Error('Error al obtener sensores de suelo');
          return res.json();
        })
        .then((data) => {
          if (!isMounted) return;

          const sortedSensors = [...data].sort((a, b) =>
            a.location?.name.localeCompare(b.location?.name)
          );

          setSoilSensors(sortedSensors);
          setError(null);
          setIsLoading(false);

          firstLoad.current = false; // ya no es primera carga
        })
        .catch((err) => {
          if (!isMounted) return;

          // Siempre mostrar error en consola
          console.error("Error al obtener sensores de suelo:", err);

          if (firstLoad.current) {
            // Solo mostrar error en UI si es la primera carga
            setError(err);
            setIsLoading(false);
          }

          // Si NO es la primera carga:
          // - NO tocamos soilSensors
          // - NO mostramos error en UI
          // - NO cambiamos isLoading
        });
    };

    fetchSoilSensors();
    const interval = setInterval(fetchSoilSensors, 60000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);

  return { soilSensors, isLoading, error };
}

export default useGetSoilSensors;
